module.exports = __webpack_public_path__ + "static/media/Jordan Sinner.6c05cf83.png";